// Spiegel von backend/services/invoice_rules.py – Anzahlungsrechnungen max. 100 %.
const slot = (kind) => (kind === "AZ2_combined" ? "AZ2" : (kind || "").toUpperCase());

export const downPayments = (invoices) => (invoices || []).filter((i) => slot(i.kind) !== "SR");

export const invoicedPercent = (invoices) =>
  downPayments(invoices).reduce((s, i) => s + (Number(i.percent) || 0), 0);

export const nextFreeKind = (invoices) => {
  const used = new Set(downPayments(invoices).map((i) => slot(i.kind)));
  let k = 1;
  while (used.has(`AZ${k}`)) k += 1;
  return `AZ${k}`;
};

export const sentToCustomer = (inv, customerEmail) => {
  const addrs = new Set([inv.recipient_email, inv.last_resent_recipient_email]);
  (inv.resend_history || []).forEach((h) => { addrs.add(h.recipient_email); (h.cc || []).forEach((c) => addrs.add(c)); });
  const clean = [...addrs].map((a) => (a || "").trim().toLowerCase()).filter(Boolean);
  const ce = (customerEmail || "").trim().toLowerCase();
  if (!ce) return clean.length > 0 || !!inv.sent_at || !!inv.last_resent_at;
  return clean.includes(ce);
};

export const invoicePdfUrl = (fileUrl, inv) =>
  `${fileUrl(inv.pdf_storage_path)}&v=${encodeURIComponent(inv.pdf_regenerated_at || inv.issued_at || "")}`;
